import { render, staticRenderFns } from "./ProductosDialogCompra.vue?vue&type=template&id=07e16b6a"
import script from "./ProductosDialogCompra.vue?vue&type=script&lang=js"
export * from "./ProductosDialogCompra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports